import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { useFormikContext } from 'formik';
import { FormValuesModel } from '../..';

// components
import { Text } from '@ui';
import WireTransfersSummaryTable from './WireTransfersSummaryTable';

const ConfirmationStep = () => {
  const { t } = useTranslation('transfers');
  const { values } = useFormikContext<FormValuesModel>();

  return (
    <>
      <Text gutterBottom>
        {t(
          'international_transfer.submit_multiple_modal.confirmation_step_description',
          { count: values.transactions.length },
        )}
      </Text>
      <WireTransfersSummaryTable />
    </>
  );
};

export default ConfirmationStep;
